import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RubriqueBlock } from "./Rubrique";
import { api } from "../api/client";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

function AssociationsSection() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/associations").then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, []);

  // Tant que le chargement n'est pas fini, on n'affiche rien de special.
  if (items === null) return <section id="associations" />;

  return (
    <section id="associations" className="vl-assos" style={{ marginTop: "2rem", scrollMarginTop: "90px" }}>
      <h2>Associations</h2>
      {items.length === 0 ? (
        // Repli : si aucune association structuree, on garde le texte libre eventuel.
        <RubriqueBlock cle="associations" />
      ) : (
        <div className="vl-assos-grid">
          {items.map((a) => (
            <div key={a.id} className="vl-asso-card">
              {a.logo_url && (
                <img className="vl-asso-logo" src={`${API_BASE}${a.logo_url}`} alt={`Logo ${a.nom}`} />
              )}
              <div className="vl-asso-body">
                <h3 className="vl-asso-nom">{a.nom}</h3>
                {a.description && <p className="vl-asso-desc">{a.description}</p>}
                {a.contact && (
                  <p className="vl-asso-contact"><strong>Contact :</strong> {a.contact}</p>
                )}
                {a.lien_web && (
                  <a className="vl-asso-lien" href={a.lien_web} target="_blank" rel="noreferrer">
                    Site internet ↗
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default function VieLocale() {
  return (
    <div className="container">
      <h1>Vie locale</h1>
      <p className="muted mb-3">Commerces, associations et équipements de la commune.</p>
      <RubriqueBlock cle="commerces" />

      <AssociationsSection />

      <RubriqueBlock cle="salle_polyvalente" />
      <RubriqueBlock cle="vie_scolaire" />

      <div className="card mt-3 rubrique-cta" style={{ marginTop: "1.5rem" }}>
        <h3 style={{ marginTop: 0 }}>📚 Bibliothèque municipale</h3>
        <p>
          Consultez le catalogue des livres disponibles, les horaires d'ouverture
          et réservez vos prochaines lectures en ligne.
        </p>
        <Link to="/bibliotheque" className="btn-primary"
              style={{ display: "inline-block", marginTop: "0.5rem" }}>
          Voir le catalogue
        </Link>
      </div>

      <div className="card mt-3 rubrique-cta" style={{ marginTop: "1.5rem" }}>
        <h3 style={{ marginTop: 0 }}>🥾 Circuits de randonnée</h3>
        <p>
          Découvrez les sentiers de La Chapelle-Saint-Fray : promenades en forêt,
          patrimoine local, points de vue panoramiques.
        </p>
        <Link to="/circuits-randonnee" className="btn-primary"
              style={{ display: "inline-block", marginTop: "0.5rem" }}>
          Voir les circuits
        </Link>
      </div>
    </div>
  );
}
